import { Button, Navbar } from "react-bootstrap";
import { NavLink as NavLinkDom } from "react-router-dom";
import styled from "styled-components";

// Centro #863bff - https://agendadocente.pucpr.br/

const href = typeof window !== "undefined" ? window.location.href : "";

const isPRD = href.includes("agendadocente.pucpr.br");

const bgCentro = isPRD ? "#8a0538" : "#863bff";
const bgMenu = isPRD ? "#e21d45" : "#5e17cf";

export const StyledNavBar = styled(Navbar)`
    background-color: ${bgCentro};
    height: 80px;
`;

export const StyledSideBar = styled(Navbar)`
    top: 0;
    bottom: 0;
    left: 0;
    min-height: 100vh !important;
    box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
    width: ${(props) => props.theme.size};
    background-color: #fafafa;
    transition: 50ms;
    display: flex;
    flex-direction: column;
`;

export const StyledNavBarBrand = styled.div`
    display: flex;
    align-items: center;
    height: 80px;
    > p {
        margin-bottom: 0px;
        color: #f8f8f8;
        padding-left: 10px;
    }
`;
// Menu #5e17cf
export const StyledContainer = styled.div`
    background-color: ${bgMenu};
    height: 100%;
    width: ${(props) => props.theme.size};
    display: flex;
    justify-content: ${(props) => props.theme.justifyContent};
    transition: 50ms;
`;

export const StyledNavbarTitle = styled.div`
    width: 100%;
`;

export const StyledTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledButton = styled(Button)`
    width: auto;
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
    outline: 0;
    font-weight: bold;
    &.btn:first-child:hover {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
    &:hover {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
    &:focus {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
        outline: 0;
    }
    &:active {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;
    }
`;

export const StyledTitle = styled.h1`
    display: flex;
    align-items: center;
    gap: 30px;
    font-size: 23px;
    line-height: 22px;
    color: #ffff;
    padding-left: 48px;
    margin: 0;
`;

export const StyledHelp = styled.a`
    font-size: 18px;
    line-height: 22px;
    color: #ffff;
    margin: 0;
    padding-right: 48px;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        color: #ffff;
    }
`;

export const StyledTitleUser = styled.p`
    font-weight: 700;
    font-size: 15px;
    line-height: 150%;
    color: #8a0538;
    margin: 0;
`;

// Group container
export const StyledNavLink = styled.div`
    display: ${(props) => props.theme.display};
    align-content: center;
    align-items: center;
    justify-content: center;
    padding: 5px 10px 5px 10px;
    text-align: ${(props) => props.theme.textAlign};
    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 6px;
    }
    > a {
        color: inherit;
        text-decoration: inherit;
        display: flex;
        justify-content: ${(props) => props.theme.textAlign};
        align-items: center;
        &:hover {
            background-color: rgba(0, 0, 0, 0.05);
            border-radius: 6px;
        }
    }
`;
// NavGroupTitle
export const StyledMenuItem = styled.div`
    display: flex;
    align-items: center;
    color: #3d3d3d;
    border: none;
    width: 100%;
    justify-content: center;
    height: 40px;
    &:hover {
        cursor: pointer;
        & p {
            color: #3d3d3d;
            font-weight: bolder;
        }
    }
    & svg {
        fill: #9654ff;
        width: 24px;
    }
`;

// NavItemTitle
export const StyledTitleMenu = styled.p`
    font-size: 15px;
    line-height: 20px;
    margin: 0;
    padding-left: 8px;
    padding-right: 8px;
`;

export const StyledNavLinkActive = styled(NavLinkDom)`
    height: 40px;
    > p {
        color: #404040;
        font-weight: 400;
        padding-left: 35px;
    }
    &.active {
        & p {
            color: #9654ff;
            font-weight: 600;
        }
    }
    &:hover {
        cursor: pointer;
        & p {
            color: #404040;
            font-weight: 600;
        }
    }
`;

export const StyledHrNav = styled.div`
    width: 75%;
    border: 1px solid #f0f2f2;
`;

export const StyledVersion = styled.span`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-align: center;
    color: #8a0538;
    font-size: 12px;
    margin-top: 20px;
    padding-left: 12px;
`;
